var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slice',[_c('div',{ref:"embed",staticClass:"slice-embed",style:(_vm.styles)},[_c('prismic-embed',{ref:"obj",attrs:{"field":_vm.url || _vm.slice.primary.url}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }